app.controller('CommonFormController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.alerts = [];

    const errorIDs = [];
    let formInvalid = false

    $scope.form_scope = $scope;

    const messages = {
        default_message: "Please ensure you have completed all fields correctly.",
        add_to_cart: "Product has NOT been added to the cart. Please ensure you have completed all fields correctly.",
        cart_check_price: "Please ensure you have completed all fields correctly."
    }

    $scope.validateForm = function (submitForm, data, defaultMessageID) {

        const form = $scope[$scope.form_id]
        if (!form) {
            return;
        }

        const showDefaultError = !$scope.list_all_errors && ($scope.show_default_error || $scope.show_cart_error);
        let defaultErrorMessage;
        if (defaultMessageID && messages[defaultMessageID]) {
            defaultErrorMessage = messages[defaultMessageID]
        } else if ($scope.form_error_message) {
            defaultErrorMessage = $scope.form_error_message;
        } else if ($scope.show_cart_error) {
            defaultErrorMessage = messages.add_to_cart;
        } else {
            defaultErrorMessage = messages.default_message;
        }

        // clear previous alerts
        $scope.alerts = [];

        formInvalid = false;
        errorIDs.length = 0;

        if (!form.$valid) {

            formInvalid = true;
            const formElement = angular.element(document.getElementsByName($scope.form_id));
            for (let fieldName in form) {
                if (form[fieldName] && form[fieldName].hasOwnProperty("$error")) {
                    for (let key in form[fieldName].$error) {
                        console.warn(fieldName + " " + key)
                        if ($scope.list_all_errors) {
                            const fieldElement = formElement.find("[name='" + fieldName + "']");
                            let fieldTitle = fieldElement.attr('title');
                            fieldTitle = fieldTitle ? fieldTitle : fieldName;
                            let reason;
                            if (key === "required") {
                                reason = " is required.";
                            } else if (key === "pattern") {
                                reason = " has invalid characters.";
                            } else if (key === "email") {
                                reason = " is invalid.";
                            } else if (key === "pwmatch") {
                                reason = " does not match.";
                            } else if (key === "min" || key === "max") {
                                reason = " has an invalid value.";
                            } else {
                                reason = ": " + key;
                            }
                            const errorID = "form_" + fieldName + key;
                            errorIDs.push(errorID);
                            $rootScope.site_helper.addErrorMessage(fieldTitle + reason, $scope.alerts, errorID);
                        }
                    }
                }
            }

            if (showDefaultError || ($scope.list_all_errors && $scope.alerts.length === 0)) {
                $rootScope.site_helper.addErrorMessage(defaultErrorMessage, $scope.alerts);
            }
            return;
        }

        if (submitForm) {
            submitForm(function (success, messages) {
                if (messages) {
                    $scope.alerts = messages;
                }
                if (success) {
                    form.$setPristine();
                }
            }, data);
        } else {
            form.$setPristine();
        }

    }

    $scope.setAlerts = function (messages) {
        $scope.alerts = messages ?? [];
    }

    function updateErrorIDs() {
        let errorID;
        const ids = [];
        if (!$scope.list_all_errors || errorIDs.length === 0) {
            return ids;
        }
        const form = $scope[$scope.form_id]
        const currentIDs = {};
        for (let fieldName in form) {
            if (form[fieldName] && form[fieldName].hasOwnProperty("$error")) {
                for (let key in form[fieldName].$error) {
                    errorID = "form_" + fieldName + key;
                    currentIDs[errorID] = true;
                }
            }
        }
        for (let i = 0; i < errorIDs.length; i++) {
            errorID = errorIDs[i];
            if (!currentIDs[errorID]) {
                errorIDs.splice(i, 1);
                i--;
            }
        }
    }

    $scope.currentFormErrors = function (inputName) {
        const form = $scope[$scope.form_id]
        if (!form || !form[inputName]) {
            return {};
        }
        return ((form[inputName].$touched && form[inputName].$dirty) || form.$submitted) && form[inputName].$error;
    }

    $scope.hasAnyErrors = function (inputName) {
        const anyErrors = $scope.currentFormErrors(inputName)
        for (let key in anyErrors) {
            if (anyErrors[key]) {
                return true;
            }
        }
        return false;
    }


    $scope.getForm = function () {
        return $scope[$scope.form_id];
    }

    $scope.checkAlerts = function () {
        const form = $scope[$scope.form_id]
        if (form) {
            if (formInvalid) {
                if (form.$valid) {
                    formInvalid = false;
                    $scope.alerts = [];
                }
            }
        }
        if ($scope.alerts.length) {
            let checkErrorIDs = [];
            let doCheck = false;
            if (formInvalid && errorIDs.length > 0) {
                updateErrorIDs();
                checkErrorIDs = checkErrorIDs.concat(errorIDs);
                doCheck = true;
            }
            if ($scope.activeFormMessageIDs) {
                checkErrorIDs = checkErrorIDs.concat($scope.activeFormMessageIDs());
                doCheck = true;
            }
            if (doCheck) {
                for (let i = 0; i < $scope.alerts.length; i++) {
                    const alert = $scope.alerts[i];
                    if (alert.message_id && !checkErrorIDs.includes(alert.message_id)) {
                        $scope.alerts.splice(i, 1);
                        i--;
                    }
                }
            }
        }
    };
}]);